module.exports = __webpack_public_path__ + "img/Palestine.7a787620.svg";